'use client';

import { createContext, ReactNode, useContext } from 'react';

export interface CustomSiteSettings {
  messageBanner?: {
    bannerType: Content.Components['MessageBannerType'];
    enable: Content.Components['SiteSettingsDto']['messageBanner']['enable'];
    headline: Content.Components['SiteSettingsDto']['messageBanner']['headline'];
    lastPublishedDateHash: Content.Components['SiteSettingsDto']['messageBanner']['lastPublishedDateHash'];
    text: Content.Components['SiteSettingsDto']['messageBanner']['text'];
  };
  userAgent?: {
    browser: {
      name?: string;
      version?: string;
    };
    cpu: {
      architecture?: string;
    };
    device: {
      model?: string;
      type?: 'mobile' | 'tablet' | string;
      vendor?: string;
    };
    engine: {
      name?: string;
      version?: string;
    };
    isBot: boolean;
    os: {
      name?: string;
      version?: string;
    };
    ua: string;
  };
}

export type SiteSettings =
  | (Partial<Content.Components['SiteSettingsDto']> & CustomSiteSettings)
  | undefined;

const SiteSettingsContext = createContext<SiteSettings>(undefined);

export const SiteSettingsProvider = ({
  children,
  initialData,
}: {
  children: ReactNode;
  initialData: SiteSettings;
}) => {
  return (
    <SiteSettingsContext.Provider value={initialData}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettingsContext = () => {
  const context = useContext(SiteSettingsContext);

  if (!context) {
    throw new Error(
      'useSiteSettingsContext must be used within a SiteSettingsProvider',
    );
  }

  return context;
};
